import { createPollingProjectConfigManager as Zt, createInstance as lr } from './node_modules/@optimizely/optimizely-sdk/dist/index.browser.es.min.js';
import { isProd, isBeta } from './envService.js';
import { OPTIMIZELY_KEY_PROD, OPTIMIZELY_KEY_DEV, SHIPPING_FEE_TOGGLE } from './constants.js';

let optimizelyClient = null;

function getFeatureToggle(
    featureKey,
    userId,
    siteId,
) {
    if (!optimizelyClient) throw new Error('Optimizely not initialized');

    return optimizelyClient
        .onReady()
        .then(() => {

            const attributes = {
                siteId: siteId
            };

            const user = optimizelyClient.createUserContext(userId, attributes);

            if (!user) {
                throw new Error('failed to create user context');
            }

            const decision = user.decide(featureKey);
            const variationKey = decision['variationKey'];

            if (variationKey === null) {
                console.log(' decision error: ', decision['reasons']);
            }

            const enabled = decision['enabled'];

            return {
                isToggleEnabled: enabled,
                variantName: variationKey
            }
        })
        .catch(error => {
            console.error('Error initializing Optimizely client:', error);
        });
}

function initOptimizely(sdkKey) {
    const pollingConfigManager = Zt({
        sdkKey: sdkKey,
    });
    optimizelyClient = lr({projectConfigManager: pollingConfigManager});
}

async function isShippingFeeToggleEnabled(cartId, siteId) {
    initOptimizely((isProd() || isBeta()) ? OPTIMIZELY_KEY_PROD : OPTIMIZELY_KEY_DEV);
    try {
        const res = await getFeatureToggle(SHIPPING_FEE_TOGGLE, cartId, siteId);
        return res;
    } catch (error) {
        console.error('Error checking feature toggle:', error);
        return { isToggleEnabled: false };
    }
}

export { getFeatureToggle, isShippingFeeToggleEnabled };
//# sourceMappingURL=toggleService.js.map
